import { useState } from 'react';
import Button from 'src/components/buttons/button';
import config from 'config/config';
import Icon from 'src/components/icon';

const PROGRAM_URL = `${config.cdn.navigator}lower-your-cholesterol/`;

const getMenu = () => (
  <section className="navigator__contents">
    <div className="navigator__contents-header">Contents</div>
    <ul className="navigator__contents__list">
      <li>
        <div className="navigator__contents__number">1.</div>
        <div className="navigator__contents__content-text">
          <a href="#1">Checking your progress</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">2.</div>
        <div className="navigator__contents__content-text">
          <a href="#2">Starting medication - statins</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">3.</div>
        <div className="navigator__contents__content-text">
          <a href="#3">Are there any side effects?</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">4.</div>
        <div className="navigator__contents__content-text">
          <a href="#4">Staying on track</a>
        </div>
      </li>
    </ul>
  </section>
);

const getPage = () => (
  <div className="navigator">
    <section className="navigator__content">
      <h1 className="navigator__title">{'Week 10: Check your progress'}</h1>
      <p>
        {`You may have revisited your doctor and found out how much you've been able to lower your cholesterol. Whether
        you got the results you wanted or not, it's important to stay on track.`}{' '}
      </p>
      <div className="visible-xs">{getMenu()}</div>

      <h2>Checking your progress</h2>
      <p>
        As you keep up your healthy lifestyle changes, you should have your cholesterol levels checked again. You may
        find that these changes have brought you closer to healthy cholesterol levels.
      </p>
      <p>
        {`However, you may find that your lifestyle changes haven't made your cholesterol levels change as quickly as
        you'd like. If this happens, it's important to keep up your healthy choices. It will still contribute to getting
        you nearer to your goals and help protect your health overall.`}
      </p>

      <h2>Starting medication - statins</h2>
      <p>
        {`If you've made lifestyle changes, your doctor may still decide to prescribe you medication. Statins is the most
        likely medication you'll be prescribed.`}
      </p>
      <p>{`This doesn't mean you should stop making healthier choices.`}</p>
      <a
        href="https://www.bhf.org.uk/informationsupport/heart-matters-magazine/medical/ask-the-experts/statin-uncertainty"
        rel="noreferrer"
        target="_blank"
      >
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text="See what the experts have to say"
        />
      </a>

      <h2>Are there any side effects?</h2>
      <p>
        Side effects are very rare. But if you do experience any side effects, its important that you go back to your GP
        and tell them about it.
      </p>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/VwhUoABSPiE"
        />
      </div>

      <h2>Staying on track</h2>
      <section className="navigator__section-half">
        <p>
          {`Whether you're getting closer to the right cholesterol levels for you, or you've hit your goal already, eating
          well and being active will help your cholesterol stay at a healthy level.`}
        </p>
        <p>
          {`At some point, you may find yourself sliding back into old habits. It's important to notice when this
          happens, make positive changes, and move forward. Don't let a bad day or week ruin the progress you've made.`}
        </p>
        <p>Here are 12 tips to get your healthy eating back on track if you overindulge.</p>
      </section>
      <img alt="Food on a plate laid out like a clock face" className="navigator__image-half" src={`${PROGRAM_URL}W10B04.jpg`} />
      <a
        href="https://www.bhf.org.uk/heart-matters-magazine/nutrition/weight/quick-fixes"
        rel="noreferrer"
        target="_blank"
      >
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text={'Read the 12 tips'}
        />
      </a>

      <img alt="Content provided by BHF" className="navigator__image-full navigator__banner-footer" src={`${PROGRAM_URL}bhf-content.jpg`} />
    </section>
  </div>
);

function Footer() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;
  return (
    <div className="navigator__footer">
      <img alt="HealthUnlocked British Heart Foundation community screenshot" className="navigator__footer__image" src={`${PROGRAM_URL}cta-community.png`} />
      <div className="navigator__footer__inner">
        <div className="navigator__footer__title">Join the conversation on HealthUnlocked</div>
        <div className="navigator__footer__description">
          {`To get the most out of your heart health journey, you'll need support. Our online community on
          HealthUnlocked brings patients, their loved-ones and healthcare experts all together online to share advice
          and encouragement.`}{' '}
          <a
            className="navigator__footer__link"
            href="https://healthunlocked.com/bhf"
            rel="noreferrer"
            target="_blank"
          >
            Join the conversation {'>'}
          </a>
        </div>
        <div className="navigator__footer__close" onClick={() => setVisible(false)}>
          <Icon icon="cross" />
        </div>
      </div>
    </div>
  );
}

const obj = {
  getPage,
  getMenu,
  Footer,
  getSeoTitle: 'Lower your cholesterol | HealthUnlocked',
};

export default obj;
